/*
 * Update-restaurant.ts
 * Description: Includes the declaration
 * of the function for updating a restaurant
 */

// Importing Axios for HTTP requests
import Axios from 'axios';
// Importing required global variables
import {APIURL} from '@/ts/variables';
// Importing an interface
import {Restaurant} from '@/ts/restaurants/validate-restaurant';

/**
 * Updating a restaurant
 *
 * @return {Object} Promise - when the restaurant is updated
 * @param {Restaurant} data - restaurant data
 * @param {String} slug - id of a restaurant
 */
export function updateRestaurant(data: Restaurant, slug: string) {
    const jwt = localStorage.getItem('jwt');
    // Using promise to handle the async properties of JavaScript
    return new Promise((resolve, reject) => {
        Axios({
            url:  APIURL + 'restaurants/' + slug,
            method: 'post',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            data,
        }).then(() => {
            resolve();
        }).catch(() => {
            reject();
        });
    });
}

/**
 * Correcting restaurant data before updating
 *
 * @param {Restaurant} data - restaurant data
 */
export function correctDataUpdate(data: Restaurant) {
    // Getting an instance of the first day
    const hours = data.working_hours.find((item) => item.day === 'Monday');
    // Setting up start and finish time for every restaurant
    let result = data.working_hours.findIndex((item) => item.day === 'Tuesday');
    data.working_hours[result].start = hours.start;
    data.working_hours[result].end = hours.end;

    result = data.working_hours.findIndex((item) => item.day === 'Wednesday');
    data.working_hours[result].start = hours.start;
    data.working_hours[result].end = hours.end;

    result = data.working_hours.findIndex((item) => item.day === 'Thursday');
    data.working_hours[result].start = hours.start;
    data.working_hours[result].end = hours.end;

    result = data.working_hours.findIndex((item) => item.day === 'Friday');
    data.working_hours[result].start = hours.start;
    data.working_hours[result].end = hours.end;
    // Turning delivery gifts from a string to an array of strings
    for (const [index, item] of Object.entries(data.delivery_prices)) {
        data.delivery_prices[index].gift = String(data.delivery_prices[index].gift).split(',');
    }
    // Setting up empty gift fields to null
    data.delivery_prices.find((item) => item.gift[0].length === 0 || item.gift[0] === 'null').gift = null;
    // Deleting empty fields
    if (data.image.length === 0) { delete data.image; }
    if (data.cover_image.length === 0) { delete data.cover_image; }
}
